import classnames from 'classnames';
import { generateCompStylers, getStylePropsFunc } from '../../../../common/utils/styles';
import DropdownElement from '../../../../hybrid/library/DropdownElement';
import FormInput from '../../../form/components/form-input/FormInput/FormInput';
import { t } from '../../../../common/components/T';
import ExcelButton from '../../../excelButton/ExcelButton';
import { svgSprite } from '../../../../hybrid/wrappers';

const BodyHead = ({
    setShowModal,
    transl,
    compStyles,
    screenWidth,
    textsData,
    pageSettings,
    inputGlobFilter,
    globalSearch,
    selectPageConfig,
    exportData,
    dataFiltersToUrl
}) => {
    const getStyleProps = (...keys) => getStylePropsFunc(compStyles, ...keys);
    const { stylers, classes } = generateCompStylers(compStyles);
    return (
        <>
            <div
                style={{
                    ...stylers.tableButtonsBlock,
                    ...stylers.adminHeadWrapper
                }}
                className={classnames(classes.tableButtonsBlock, classes.adminHeadWrapper)}
            >
                <div {...getStyleProps('flexRow')}>
                    {textsData.settingsButton !== false ? (
                        !screenWidth ? (
                            <div>
                                {/*{svgSprite('gear', {*/} {/*})}*/}
                                {/*<p>{textsData.settingsButton || t('gridHeader-displaySetting', 'Настройка отображения', 'widget', transl, "gridFilter" )}</p>*/}
                            </div>
                        ) : (
                            <div>
                                {/*{svgSprite('gear', {*/} {/*})}*/}
                            </div>
                        )
                    ) : textsData.pageTitle ? (
                        <p {...getStyleProps('pageTitleText')}>
                            {textsData.pageTitle ||
                                t('gridHeader-displaySetting', 'Настройка отображения', 'widget', transl, 'gridFilter')}
                        </p>
                    ) : null}
                </div>
                <div {...getStyleProps('flexRow')}>
                    <div {...getStyleProps('selectPageWrap')}>
                        <p {...getStyleProps('selectPageText')}>
                            {(textsData.itemOnPage ||
                                (screenWidth
                                    ? t('gridHeader-selectPageTextXs', 'Записей', 'widget', transl, 'gridFilter')
                                    : t('gridHeader-sselectPageText', 'Записей на странице', 'widget', transl, 'gridFilter'))) +
                                ':'}
                        </p>
                        <DropdownElement componentConfig={selectPageConfig} />
                    </div>
                    {!screenWidth && (
                        <div {...getStyleProps('searthTable')}>
                            {!pageSettings?.hideSearchInput ? (
                                <>
                                    <FormInput
                                        value={inputGlobFilter?.[0]}
                                        compStyle={{
                                            icon: { fill: 'var(--greyExtraDarkColor)' },
                                            wrapper: {
                                                ...stylers.searthTableInput,
                                                className: classes.searthTableInput
                                            },
                                            global: { icon: { width: '18px' } },
                                            clear: { icon: { width: '10px' } }
                                        }}
                                        handlers={{
                                            onChange: (val) => {
                                                globalSearch(val);
                                            }
                                        }}
                                        search={{
                                            type: 'onInput',
                                            icon: 'search-thin'
                                        }}
                                        placeholder={
                                            textsData.globalSearthPlaceholder ||
                                            t('gridHeader-searchUser', 'Поиск пользователя', 'widget', transl, 'gridFilter')
                                        }
                                        buttons={
                                            !pageSettings?.hideGlobalSearch
                                                ? {
                                                      global: {
                                                          icon: 'sliders',
                                                          handler: () => setShowModal(true)
                                                      },
                                                      ...(inputGlobFilter?.[0]
                                                          ? {
                                                                clear: {
                                                                    icon: 'cross',
                                                                    handler: () => {
                                                                        globalSearch('');
                                                                    }
                                                                }
                                                            }
                                                          : {})
                                                  }
                                                : {}
                                        }
                                    />
                                </>
                            ) : (
                                <div
                                    {...getStyleProps('searthFilterOpen', 'searthFilterOpenStatic', 'formCursorPointer')}
                                    onClick={() => setShowModal(true)}
                                >
                                    {svgSprite('search-thin', getStyleProps('userSearthSvgFillGrey'))}
                                </div>
                            )}
                        </div>
                    )}
                    {exportData ? <ExcelButton filter={dataFiltersToUrl} exportData={exportData} /> : null}
                </div>
            </div>
        </>
    );
};
export default BodyHead;
